export const PayoutBeneficiaryFilters = {
  MY_COMPANY: 'my-company',
  BUSINESS: 'business',
  INDIVIDUAL: 'individual',
}

export type PayoutBeneficiaryFilter =
  (typeof PayoutBeneficiaryFilters)[keyof typeof PayoutBeneficiaryFilters]

export const MAX_GBP_PAYMENT_AMOUNT = 1000000

export const FeeErrors = {
  BVNK_0000: 'bvnk:0000',
  BAD_REQUEST_ERROR: 'bvnk:payment:0001',
  BENEFICIARY_VALIDATION_ERROR: 'bvnk:payment:0005',
}

export const IBAN_PATTERN = /^[A-Z]{2}[0-9]{2}[A-Z0-9]+$/

export const FIAT_SEND_ERRORS = {
  INSUFFICIENT_BALANCE: 'INSUFFICIENT_BALANCE',
  PAYMENT_NOT_SUPPORTED: 'PAYMENT_NOT_SUPPORTED',
} as const

export const FIAT_SEND_EOF = {
  SUCCESS: 'SUCCESS',
  APPROVAL: 'APPROVAL',
} as const

export const PAYOUT_VERSIONS = {
  LEGACY_WITHDRAW: 'LEGACY_WITHDRAW',
  LEGACY_PAY: 'LEGACY_PAY',
  UNIFIED_PAYOUT_V2: 'UNIFIED_PAYOUT_V2',
} as const

export const ELIGIBILITY_MESSAGE_MAPPING: Record<string, string> = {
  FIRST_PARTY: 'wallets.fiatSend.eligibilityMessageMapping.firstParty',
  PAYMENT_METHOD_UNAVAILABLE: 'wallets.fiatSend.eligibilityMessageMapping.paymentMethodUnavailable',
  THIRD_PARTY_TO_INDIVIDUALS: 'wallets.fiatSend.eligibilityMessageMapping.thirdPartyToIndividuals',
  THIRD_PARTY_TO_BUSINESSES: 'wallets.fiatSend.eligibilityMessageMapping.thirdPartyToBusinesses',
} as const
